import { useEffect, useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../css/home.css';
import '../css/swiper.css';
import { getLatestPressAction } from '../../apis/apiAction';
import config from '../../config/config';

const LatestPress = () => {
  const [pressData, setPressData] = useState([]);

  useEffect(() => {
    getLatestPress();
  }, []);

  const getLatestPress = async () => {
    const res = await getLatestPressAction();
    setPressData(res.data);
  };

  return (
    <section className="globalpress">
      <Container>
        <Row>
          <Col lg={12} className="mb-5">
            <div className="d-md-flex justify-content-between">
              <div className="heading">
                <h1 className="text-white fw-normal">Latest News</h1>
              </div>
              <div className="text-end">
                <Link
                  to={`${config.baseUrl}news`}
                  className="border-0 fw-semibold me-1 text-white text-decoration-none"
                >
                  More News
                  <span className="ms-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="21"
                      viewBox="0 0 24 25"
                      fill="none"
                    >
                      <path
                        d="M4 12.4789H20M20 12.4789L14 18.4789M20 12.4789L14 6.47894"
                        stroke="#61C19B"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </Link>
              </div>
            </div>
          </Col>
          <Col lg={12}>
            <div className="pressContent">
              <Row>
                {pressData.slice(0, 3).map((press, index) => (
                  <Col key={index} xl={4} lg={8} className="mb-4">
                    <Link
                      to={press.link}
                      target="_blank"
                      className="text-decoration-none"
                    >
                      <Card>
                        <Card.Body className="p-0">
                          <div className="">
                            <div className="d-flex gap-3">
                              <div>
                                <img
                                  src="assets/images/press/image4.png"
                                  alt=""
                                  // style={{ width: '212px', height: '120px' }}
                                />
                              </div>
                              <div className="">
                                <h5 className="text-grey">
                                  {press.title.length > 50
                                    ? press.title.substring(0, 50) + '...'
                                    : press.title}
                                </h5>
                                <p className="mb-0 text-dark-grey">
                                  {press.publishedDate}
                                </p>
                              </div>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Link>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default LatestPress;
